import { render, staticRenderFns } from "./ItalyConfig.vue?vue&type=template&id=2c02338a&scoped=true"
import script from "./ItalyConfig.vue?vue&type=script&lang=js"
export * from "./ItalyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02338a",
  null
  
)

export default component.exports